module.exports = __webpack_public_path__ + "images/logo.png?ee93dfd";


//////////////////
// WEBPACK FOOTER
// ./assets/component/base/logo.png
// module id = 331
// module chunks = 0